import gql from 'graphql-tag'

export default gql`
  query getWorkPreferences($id: String!) {
    getExpert(id: $id) {
      id
      hasCurrentClients
      legacyFreelancerId
      paroIncomeStatus
      workPreference {
        id
        contactStylePreference
        contactTimePreference
        isOpenToOnsite
        intendedMonthlyIncome
        projectType
        weeklyWorkloadHours
        totalFreelanceExperience
      }

      onboardingStep
    }
  }
`
